import React from 'react';
import styles from './style/modalHeader.module.css';

const ModalHeader = ({ heading }:{ heading:string }) => (
  <div className={styles.modalHeader}>
    <h3 className="display6">{ heading }</h3>
  </div>
);

export default ModalHeader;
